import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

export default function LabeledCheckbox(props) {
  
  return (
    <FormControlLabel
      sx={{height: '30px', ...(props?.sx || {})}}
      className={'width-fit-content'}
      label={props.label}
      disabled={props?.disabled}
      control={
        <Checkbox 
          {...props.checkboxProps}
          name={props?.name}
          size={'small'}
          checked={props.checked}
          onChange={(e, checked) => props.handleCheck(checked)}
        />
      } 
    />
  )
}
